import { useEffect, useState } from 'react';
import type { Product, StoreSettings } from '../types';
import { conditionLabels, money } from '../utils/labels';

export default function ProductModal({ product, settings, categoryName, onClose, onOrder, onShare }: {
  product: Product;
  settings: StoreSettings;
  categoryName: string;
  onClose: () => void;
  onOrder: () => void;
  onShare: () => void;
}) {
  const [selected, setSelected] = useState(0);
  useEffect(() => {
    const close = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', close);
    document.body.classList.add('modal-open');
    return () => { window.removeEventListener('keydown', close); document.body.classList.remove('modal-open'); };
  }, [onClose]);

  return <div className="modal-backdrop" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className="product-modal" role="dialog" aria-modal="true" aria-label={product.title}>
      <button className="modal-close" onClick={onClose} aria-label="סגירה">×</button>
      <div className="modal-gallery">
        <div className="modal-main-image">{product.images[selected] && <img src={product.images[selected].url} alt={product.title} />}</div>
        <div className="thumbnail-row large">{product.images.map((image, index) => <button key={image.id} className={selected === index ? 'active' : ''} onClick={() => setSelected(index)}><img src={image.url} alt="" /></button>)}</div>
      </div>
      <div className="modal-details">
        {product.status === 'reserved' && <span className="reserved-label">המוצר שמור</span>}
        <p className="eyebrow">{categoryName}</p>
        <h1>{product.title}</h1>
        <p className="condition-line">{conditionLabels[product.condition]}</p>
        {product.description && <p className="description">{product.description}</p>}
        <div className="price-row modal-price"><strong>{money(product.price_cents)}</strong>{product.old_price_cents !== null && <del>{money(product.old_price_cents)}</del>}</div>
        <div className="purchase-info">
          <div className="payment-logos"><span className="bit-logo">bit</span><span className="paybox-logo">PayBox</span><span>מזומן</span></div>
          <p>{settings.payment_text}</p><p>{settings.pickup_text}</p><p>{settings.delivery_text}</p>
        </div>
        <div className="modal-actions"><button className="primary" disabled={product.status === 'reserved'} onClick={onOrder}>{product.status === 'reserved' ? 'המוצר שמור כרגע' : 'שליחת הזמנה ב-WhatsApp'}</button><button className="secondary" onClick={onShare}>שיתוף</button></div>
      </div>
    </section>
  </div>;
}
